<template>
    <section class="header_menu" v-show="header">
       
    <header :class="{'header-back-none': infoViewTopChk, }">
        <div :class="['wrap', {'header-back-none-wrap': (infoViewChk || loginViewChk)},]">

            <div class="left_btn">
                <button @click="goRouteBack()" :class="{ 'www' : infoViewTopChk }">
                    <i class="far fa-chevron-left"></i>
                    <!-- <img :src="`${$store.state.dir}images/header_back${(infoViewTopChk)?'_w':''}.png`"> -->
                </button>
            </div>

            <h2>{{headerTitle}}</h2>

            <div class="right_btn" v-if="headerBookmark">
                <button><img :src="`${$store.state.dir}images/bookmark${(infoViewTopChk)?'_w':''}.png`"></button>
            </div>

        </div>
    </header>
    <div class="header_blank" v-if="headerBlank"></div>
</section>


</template>

<script>
import { mapState } from 'vuex';
export default {
    name:'Header',
    data() {
        return {
            scrollChk: true,
            prevRouteName: null,
        }
    },
    watch: {
        '$route': {
            handler(newVal, oldVal) {
                this.prevRouteName = oldVal.name;
            },
        }
    },
    computed: {
        ...mapState({
            header: state => state.header,
            headerTitle: state => state.headerTitle,
            headerBlank: state => state.headerBlank,
            headerBookmark: state => state.headerBookmark,

            routeBack: state => state.routeBack,
        }),

        windowScrollY(){
            return window.scrollY;
        },

        infoViewChk(){
            return [
                'ScInfo',
                'ShopInfo',
                'DealerInfo',
                // 'Login',
            ].includes(this.$route.name);
        },

        loginViewChk(){
            return [
                'Login',
            ].includes(this.$route.name);
        },

        infoViewTopChk(){
            return (this.scrollChk && this.infoViewChk);
        },
    },

    created() {},

    mounted () {
        window.onscroll = () => {
            console.log(window);
            console.log(window.scrollY);
            if(this.infoViewChk) {
                if(window.scrollY <= 0) this.scrollChk = true;
                else this.scrollChk = false;
            }
        };
    },

    methods: {
        goRouteBack() {
            this.$store.commit('SET_TRANSITION_NAME_SLIDE_RIGHT');

            if(
                this.prevRouteName == null ||
                this.prevRouteName == 'Intro' ||
                ( this.loginViewChk && this.prevRouteName != 'Menu' )
            ) {
                this.$router.push('/main');
            }

            else {
                this.$router.go(this.routeBack);
            }                
        }
    },
}
</script>

<style scoped>

.header-back-none {
    background: none;
    box-shadow:none;
}

.header-back-none-wrap {
    border-bottom: none;
}
</style>